/** POS.md §11. Query: `branch_id`, `from_date`, `to_date`, `page`, `length`. */
export const POS_REPORT_BASE = '/api/backoffice/pos-report'

export interface PosReportDef {
  key: string
  label: string
  permission: string
  path: string
  dated: boolean
}

export const POS_REPORTS: readonly PosReportDef[] = [
  { key: 'sales_by_product', label: 'Sales by product', permission: 'pos_reports:sales_by_product', path: 'sales-by-product', dated: true },
  { key: 'sales_by_payment_method', label: 'Sales by payment method', permission: 'pos_reports:sales_by_payment_method', path: 'sales-by-payment-method', dated: true },
  { key: 'stock_values', label: 'Stock value', permission: 'pos_reports:stock_values', path: 'stock-values', dated: false },
  { key: 'customers', label: 'Customers', permission: 'pos_reports:customers', path: 'customers', dated: true },
  { key: 'adjustments', label: 'Stock adjustments', permission: 'pos_reports:adjustments', path: 'adjustments', dated: true },
  { key: 'credit_repay', label: 'Credit repayments', permission: 'pos_reports:credit_repay', path: 'credit-repay', dated: true },
  { key: 'shifts', label: 'Shifts', permission: 'pos_reports:shifts', path: 'shifts', dated: false },
]

export const POS_REPORT_HIDDEN_FIELDS: readonly string[] = ['_id', 'business_id', '__v', 'id']

export const reportColumnLabel = (key: string) => key.replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase())
